let dev = {
    // apiUrl:'http://127.0.0.1:9501/Admin',
    // serviceUrl:'http://127.0.0.1:9501/Service',
    // uploadUrl:'http://127.0.0.1:9501/Admin/Upload/upload',
    // assetsUrl:'http://127.0.0.1:9501/static',
    // editUrl:'http://www.clb.org.cn',
    // webUrl:'http://www.clb.org.cn',
    
    apiUrl:'http://api.clb.org.cn/Admin',
    serviceUrl:'http://api.clb.org.cn/Service',
    uploadUrl:'http://api.clb.org.cn/Admin/Upload/upload',
    assetsUrl:'http://api.clb.org.cn/static',
    editUrl:'http://api.clb.org.cn/UEditor',
    webUrl:'http://www.clb.org.cn',
}

let pro = {
    apiUrl:'http://api.clb.org.cn/Admin',
    serviceUrl:'http://api.clb.org.cn/Service',
    uploadUrl:'http://api.clb.org.cn/Admin/Upload/upload',
    assetsUrl:'http://api.clb.org.cn/static',
    editUrl:'http://api.clb.org.cn/UEditor',
    webUrl:'http://www.clb.org.cn',
    
    // apiUrl:'http://api.test.clb.org.cn/Admin',
    // serviceUrl:'http://api.test.clb.org.cn/Service',
    // uploadUrl:'http://api.test.clb.org.cn/Admin/Upload/upload',
    // assetsUrl:'http://api.test.clb.org.cn/static',
    // editUrl:'http://www.clb.org.cn',
    // webUrl:'http://www.test.clb.org.cn'
}
export default {
    // 本地环境
    // apiUrl:'http://127.0.0.1:9501/Admin',
    // serviceUrl:'http://api.clb.org.cn/Service',
    // uploadUrl:'http://127.0.0.1:9501/Admin/Upload/upload',
    // assetsUrl:'http://127.0.0.1:9501',
    // editUrl:'http://www.clb.org.cn',
    // webUrl:'http://www.clb.org.cn',
    
    // 开发服务器
    // apiUrl:'http://api.test.clb.org.cn/Admin',
    // serviceUrl:'http://api.test.clb.org.cn/Service',
    // uploadUrl:'http://api.test.clb.org.cn/Admin/Upload/upload',
    // assetsUrl:'http://api.test.clb.org.cn/static',
    // editUrl:'http://www.clb.org.cn',
    
    // 测试域名
    // apiUrl:'http://api.test.clb.miihe.com/Admin',
    // serviceUrl:'http://api.test.clb.miihe.com/Service',
    // uploadUrl:'http://api.test.clb.miihe.com/Admin/Upload/upload',
    // assetsUrl:'http://api.test.clb.miihe.com/static',
    // editUrl:'http://www.clb.org.cn',
    // webUrl:'http://www.test.clb.org.cn',
    
    // 线上环境
    apiUrl:process.env.NODE_ENV === 'development' ? dev.apiUrl : pro.apiUrl,
    serviceUrl:process.env.NODE_ENV === 'development' ? dev.serviceUrl : pro.serviceUrl,
    uploadUrl:process.env.NODE_ENV === 'development' ? dev.uploadUrl : pro.uploadUrl,
    assetsUrl:process.env.NODE_ENV === 'development' ? dev.assetsUrl : pro.assetsUrl,
    editUrl:process.env.NODE_ENV === 'development' ? dev.editUrl : pro.editUrl,
    webUrl:process.env.NODE_ENV === 'development' ? dev.webUrl : pro.webUrl,

    secret:'zhaobiaowang!@#',
}
